var listaEstados = [
    "RESERVADO_PARA_LEITURA",
    "COMPRADO_AGUARDANDO_RECEBIMENTO",
    "COMPRADO_CANCELADO",
    "COMPRADO_RECEBIDO_AGUARDANDO_APROVACAO",
    "RECEBIDO_RECUSADO_AGUARDANDO_MEDIACAO",
    "RECEBIDO_APROVADO_AGUARDANDO_ARMAZENAMENTO",
    "MEDIACAO_CONCLUIDA",
    "ARMAZENADO",
    "ARMAZENADO_A_PUBLICAR",
    "PUBLICADO",
    "VENDIDO_AGUARDANDO_SEPARACAO",
    "VENDIDO_DESPACHADO",
    "VENDIDO_CANCELADO",
    "ARQUIVADO"
]

export default listaEstados